import React from 'react';
import './SocialSidebar.css';

const socials = [
  { icon: 'fab fa-facebook-f',  label: 'Facebook',  href: 'https://facebook.com',                  bg: '#1877F2' },
  { icon: 'fab fa-linkedin-in', label: 'LinkedIn',  href: 'https://linkedin.com',                  bg: '#0A66C2' },
  { icon: 'fab fa-youtube',     label: 'YouTube',   href: 'https://youtube.com',                   bg: '#FF0000' },
  { icon: 'fab fa-whatsapp',    label: 'WhatsApp',  href: 'https://wa.me/917477471006',            bg: '#25D366' },
  { icon: 'fab fa-instagram',   label: 'Instagram', href: 'https://instagram.com',                 bg: 'linear-gradient(135deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)' },
  { icon: 'fa fa-phone',        label: 'Call Us',   href: 'tel:+917477471006',                     bg: '#1B6EF3' },
  { icon: 'fa fa-envelope',     label: 'Email',     href: 'mailto:info@bricksnhome.com',           bg: '#EA4335' },
];

export default function SocialSidebar() {
  return (
    <div className="social-sidebar">
      {socials.map((s, i) => (
        <a
          key={i}
          href={s.href}
          target={s.href.startsWith('http') ? '_blank' : undefined}
          rel="noreferrer"
          className="ss-item"
          aria-label={s.label}
          style={{ background: s.bg }}
        >
          <div className="ss-icon-wrap">
            <i className={s.icon} />
          </div>
          <span className="ss-label">{s.label}</span>
        </a>
      ))}
    </div>
  );
}
